import { queryKeyFn } from '../../generated/sitContext';
// @ts-expect-error -- we are using this for invalidation, so we don't want to query params
export const approvalsEntriesQueryKey = queryKeyFn({
    path: '/approvals/entries',
    operationId: 'getApiApprovalsEntries',
    variables: {},
});
// @ts-expect-error -- we are using this for invalidation, so we don't want to query params
export const approvalsTimesheetsQueryKey = queryKeyFn({
    path: '/approvals/timesheets',
    operationId: 'getApiApprovalsTimesheets',
    variables: {},
});
//# sourceMappingURL=query-key.js.map